export default __webpack_public_path__ + "static/media/KOD0096-min.155e7e77.webp";